// import axios from '../../static/js/request'
export default {
  namespaced: true,
  state: {
    routes: [],
    cacheRoutes: [],
    currentRoute: {}
  },
  // mutations 修改器，用于修改state中的定义的状态变量,同步
  mutations: {
    SET_ROUTES(state, payload) {
      state.routes = payload
    },
    SET_CACHEROUTES(state, payload) {
      state.cacheRoutes = payload
    },
    SET_CURRENTROUTE(state, payload) {
      state.currentRoute = payload
    }
  },
  // 存放异步操作，由 action 去触发 mutation
  actions: {}
}
